import CommerceApiFetchWrapper from '/Foundation/Common/code/Utils/CommerceApiFetchWrapper.js';
import { br_cartAddition } from '/Foundation/Bloomreach/code/Events/BloomreachCart.js';
import { store } from '/Feature/Cart/code/Views/Feature/Cart/ShoppingCart/React/index.jsx';
import { setCartIdCookie } from '/Foundation/React/code/Utilities/HelperUtilities.js';
import { toggleMiniCart } from '/Feature/Cart/code/Views/Feature/Cart/ShoppingCart/React/Slices/CartSlice.jsx';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QuickViewModal } from '/Foundation/Common/code/Views/Foundation/Common/QuickViewModal/QuickViewModal.jsx';
import { QuickViewPDP } from './RelatedProductsSlider_QuickView.jsx';

const bindModalButtonEvents = () => {
  document.querySelectorAll('.productSliderItem__infoButton').forEach((btn) => {
    var productId = btn.getAttribute('data-productId');
    var canonical = btn.getAttribute('data-canonical');
    if (!productId) return;

    if (btn.dataset.qvAttached) return;
    btn.dataset.qvAttached = '1';

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const item = btn.closest('.productSliderItem');
      if (!item) return;

      const infoNode =
        item.querySelector('.productSliderItem__infoContent') || item.querySelector('.productSliderItem__details');
      const html = infoNode ? infoNode.innerHTML : item.dataset.info || null;

      // create a transient mount node and render the React QuickViewModal
      const mount = document.createElement('div');
      mount.className = 'rp-quickview-react-root';
      document.body.appendChild(mount);

      const root = ReactDOM.createRoot(mount);
      const onRequestClose = () => {
        root.unmount();
        mount.remove();
      };

      // Render the modal. Pass whatever the modal expects; common props include isOpen, onClose and html/item

      fetchProductQuickView(productId, canonical).then((data) => {
        root.render(
          <QuickViewModal isOpen={true} onRequestClose={onRequestClose}>
            <QuickViewPDP product={data} />
          </QuickViewModal>
        );
      });
    });
  });
};

const fetchProductQuickView = async (productId, canonical) => {
  if (!productId) return null;

  try {
    const res = await fetch('/api/sitecore/product/GetProductQuickView', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId, canonical }),
    });

    if (!res.ok) {
      console.error('Error fetching product quick view (POST):', res.status, res.statusText);
      return null;
    }

    const data = await res.json();
    return data || null;
  } catch (error) {
    console.error('Error fetching product quick view (POST):', error);
    return null;
  }
};

const initializedSliders = new WeakSet();

export const initSlider = (container) => {
  if (!container) return;

  const slider = container.querySelector('.promotion');
  if (!slider) return;

  if (initializedSliders.has(container)) {
    bindModalButtonEvents();
    return;
  }

  initializedSliders.add(container);
  const arrowLeft = container.querySelector('.arrow');
  const arrowRight = container.querySelector('.arrow-right');
  const addToCartButtons = slider.querySelectorAll('.accessory-add-to-cart:not([disabled])');

  let scrollAmount = 0;

  const bindEvents = () => {
    arrowLeft?.addEventListener('click', () => horizontalScroll('back'));
    arrowRight?.addEventListener('click', horizontalScroll);
    window.addEventListener('resize', () => {
      renderArrows();
      hideScrollAndArrows();
    });
    slider.addEventListener('scroll', () => {
      renderArrows();
      hideScrollAndArrows();
    });
    window.addEventListener('load', () => {
      hideScrollAndArrows();
    });

    const allProducts = Array.from(addToCartButtons)
      .map((button) => ({
        productId: button.dataset.productId,
        skuIds: [button.dataset.erpoutdoor],
      }))
      .filter((p) => p.productId && p.skuIds.length > 0);

    if (allProducts.length === 0 || !window._THULEDATA?.isB2CEnabled) return;

    CommerceApiFetchWrapper('/cart/inventory-batch', {
      method: 'POST',
      body: JSON.stringify(allProducts),
    }).then((inventoryInfo) => {
      const productItems = Array.from(slider.querySelectorAll('.productSliderItem'))
        .map((item) => {
          const button = item.querySelector('.accessory-add-to-cart');
          const productId = button.dataset.productId;
          const erpOutdoor = button.dataset.erpoutdoor;
          const isSellable = button.dataset.isSellable === 'True';

          let isEnabled = false;

          if (isSellable && productId) {
            const productInventory = inventoryInfo?.items?.find((i) => i.productId === productId);
            isEnabled = productInventory?.isInStock === true;
          }

          button.disabled = !isEnabled;

          return { item, button, isEnabled, erpOutdoor };
        })
        .sort((a, b) => b.isEnabled - a.isEnabled); // Enabled first

      // Reorder DOM
      productItems.forEach(({ item }) => slider.appendChild(item));

      // Attach click handlers to enabled buttons only
      productItems
        .filter(({ isEnabled }) => isEnabled)
        .forEach(({ button, erpOutdoor }) => {
          button.addEventListener('click', async () => {
            if (button.classList.contains('loading')) return;

            button.classList.add('loading');
            let atcAnalyticsElement = button.parentElement.querySelector('.analytics-data');

            const state = store.getState().Cart;
            let lineItems = state.lineItems?.length > 0 ? state.lineItems : window._THULEDATA.cartLineItems;

            if (lineItems?.length > 0) {
              let existingProducts = [];
              let newProducts = [];

              const matchingProductInCart = lineItems.find((x) => x.sku === erpOutdoor && !x.isFreeGift);
              if (matchingProductInCart)
                existingProducts.push({
                  id: matchingProductInCart.id,
                  quantity: matchingProductInCart.quantity + 1,
                });
              else newProducts.push(erpOutdoor);

              if (existingProducts.length > 0) {
                let lineItems = [];
                existingProducts.forEach((product) => {
                  lineItems.push({
                    id: product.id,
                    quantity: product.quantity,
                  });
                });

                const data = {
                  LineItems: lineItems,
                };

                const cart = await CommerceApiFetchWrapper('/cart/update-quantity', {
                  method: 'POST',
                  body: JSON.stringify(data),
                });
                if (newProducts.length === 0) {
                  store.dispatch(toggleMiniCart(true));
                  handleCartSuccess(cart, button);
                }
                br_cartAddition(cart);
                window.dispatchEvent(new Event('cart-updated'));
              }
              if (newProducts.length > 0) {
                const data = {
                  productIds: [erpOutdoor],
                  quantity: 1,
                };
                let cart = await addCartLines(data, atcAnalyticsElement);
                handleCartSuccess(cart, button);
              }
            } else {
              const data = {
                productIds: [erpOutdoor],
                quantity: 1,
              };
              let cart = await addCartLines(data, atcAnalyticsElement);
              handleCartSuccess(cart, button);
            }
          });
        });

      renderArrows();
    });
  };

  const handleCartSuccess = (cart, button) => {
    if (cart) {
      button.classList.remove('loading');
      button.classList.add('success');
      setTimeout(() => {
        button.classList.remove('success');
      }, [3000]);
    } else {
      button.classList.remove('loading');
    }
  };

  const horizontalScroll = (direction) => {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === 'back') {
        slider.scrollLeft -= 70;
      } else {
        slider.scrollLeft += 70;
      }

      setArrowsFromScrollStates();
      scrollAmount += 70;
      if (scrollAmount >= 500) {
        window.clearInterval(slideTimer);
      }
    }, 27);
  };

  const renderArrows = () => {
    if (slider.scrollWidth > slider.clientWidth) {
      setArrowsFromScrollStates();
    } else {
      arrowLeft?.classList.add('disabled');
      arrowRight?.classList.add('disabled');
    }
  };

  const setArrowsFromScrollStates = () => {
    if (slider.scrollWidth - 1 < slider.clientWidth + slider.scrollLeft) {
      arrowRight?.classList.add('disabled');
    } else {
      arrowRight?.classList.remove('disabled');
    }
    if (slider.scrollLeft === 0) {
      arrowLeft?.classList.add('disabled');
    } else {
      arrowLeft?.classList.remove('disabled');
    }
  };

  const hideScrollAndArrows = () => {
    let cards = slider.querySelectorAll('.productSliderItem');

    if (cards.length === 0) {
      arrowLeft.classList.add('d-none');
      arrowRight.classList.add('d-none');
      return;
    }

    if (slider.scrollWidth <= slider.clientWidth) {
      arrowLeft.classList.add('d-none');
      arrowRight.classList.add('d-none');
    } else {
      arrowLeft.classList.remove('d-none');
      arrowRight.classList.remove('d-none');
    }
  };

  bindEvents();
  renderArrows();
  bindModalButtonEvents();
};

const addCartLines = async (body) => {
  await CommerceApiFetchWrapper('/cart/add-cart-line', {
    method: 'POST',
    body: JSON.stringify(body),
  })
    .then((data) => {
      if (!data) return null;

      setCartIdCookie(data.id);
      store.dispatch(toggleMiniCart(true));
      br_cartAddition(data);
      window.dispatchEvent(new Event('cart-updated'));

      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

document.addEventListener('DOMContentLoaded', function () {
  Array.from(
    document.querySelectorAll('.accessory-promotion-container:not(.similar-products-slider):not(.react-product-slider)')
  ).forEach((container) => {
    initSlider(container);
  });
});
